import React from 'react';
import { useLanguage, LANGUAGES } from '../../hooks/useLanguage.js';

/**
 * Frontend Language Switcher — a plain <select> in the global nav (see
 * Navbar.jsx). Selecting a language persists it (store/languageStore.js,
 * localStorage) and immediately re-renders every article-displaying
 * component in that language wherever a translation exists, falling back
 * to English elsewhere (hooks/useLanguage.js's translate()).
 */
export default function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();

  return (
    <select
      value={language}
      onChange={(e) => setLanguage(e.target.value)}
      aria-label="Choose language"
      className="language-switcher"
      style={{ fontSize: 12, padding: '4px 6px', borderRadius: 4 }}
    >
      {LANGUAGES.map((l) => (
        <option key={l.code} value={l.code}>
          {l.label}
        </option>
      ))}
    </select>
  );
}
